let debugDataViewerIsAllowed = false;

export function initDebugDataViewer(): void {
    debugDataViewerIsAllowed = (window as any).glideDDV === true;
}

export function getIsDebugDataViewerAllowed(): boolean {
    return debugDataViewerIsAllowed;
}
